import React, { useContext } from 'react'

import { ItemCardVariant } from '../types'

import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import ViewNearbyExperiencesCta from 'tripPlanner/components/Buttons/ViewNearbyExperiencesCta'
import LEOfferCTAs from 'tripPlanner/components/ItemCard/Common/LEOfferCTAs'
import { VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import { ExperienceItem } from 'tripPlanner/types/tripItem'
import { addTripIdParam } from 'tripPlanner/utils/url'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'

interface Props {
  item: Utils.RequiredProp<ExperienceItem, 'savedItemData'>
  isOfferAvailable: boolean
  variant: ItemCardVariant
  offerLink: string
  onViewOffer?: () => void
}

export default function PlannedExperienceCtaContent(props: Props) {
  const { isOfferAvailable, item, item: { tripId }, offerLink, onViewOffer } = props

  const canEdit = useCanEditTrip()
  const tripContext = useContext(TripContext)
  const isPublicTrip = tripContext?.isPublicTrip

  if (isPublicTrip) {
    return (
      <Group direction="horizontal" gap={12}>
        <SaveTripItemButton item={item} />
        <TextButton kind="primary" to={offerLink} target="_blank" onClick={onViewOffer}>
          {VIEW_OFFER_COPY}
        </TextButton>
      </Group>
    )
  } else if (!isOfferAvailable) {
    const hasPlannedInfo = !!item.startDate

    return (
      <Group
        direction="horizontal"
        gap={8}
        tabletHorizontalAlign="space-between"
        horizontalAlign="stretch"
      >
        {hasPlannedInfo && (
          <TextButton kind="tertiary" to={addTripIdParam(offerLink, tripId, canEdit)} target="_blank" onClick={onViewOffer}>
            Change details
          </TextButton>
        )}
        {item.place.type === 'GEO' && (
          <ViewNearbyExperiencesCta
            lat={item.place.point.lat}
            lng={item.place.point.lng}
            tripId={item.tripId}
            showSearch={props.variant === 'tripSummary'}
          />
        )}
      </Group>
    )
  } else {
    return <LEOfferCTAs item={item} variant={props.variant} />
  }
}
